import React from 'react';
import { Flex } from '@adobe/react-spectrum';
import { Text } from 'app/views/components/typography/Text';
import TwitterIcon from './twitter.svg';
const BrandColor = '#1DA1F2';
const BrandStyle = { color: BrandColor };
export const Twitter = () => React.createElement(TwitterIcon, { fill: BrandColor });
export const TwitterHandle = (props) => (React.createElement(Flex, { alignItems: "center", direction: "row", gap: "size-50" },
    React.createElement(Twitter, null),
    React.createElement(Text, { size: "S", style: BrandStyle },
        "@",
        props.handle)));
